import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "course_id": {
      "column": {
        "default": null,
        "name": "course_id",
        "null": false,
        "type": null
      },
      "name": "course_id",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "expected_minutes": {
      "column": {
        "default": null,
        "name": "expected_minutes",
        "null": true,
        "type": "integer"
      },
      "name": "expected_minutes",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "position": {
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": false
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "appetizer": {
      "column": null,
      "name": "appetizer",
      "selected_by_default": false,
      "translated": true
    },
    "appetizer_da": {
      "column": null,
      "name": "appetizer_da",
      "selected_by_default": false,
      "translated": false
    },
    "appetizer_en": {
      "column": null,
      "name": "appetizer_en",
      "selected_by_default": false,
      "translated": false
    },
    "appetizer_no": {
      "column": null,
      "name": "appetizer_no",
      "selected_by_default": false,
      "translated": false
    },
    "appetizer_se": {
      "column": null,
      "name": "appetizer_se",
      "selected_by_default": false,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "CourseModule",
  "collectionKey": "course_modules",
  "collectionName": "course_modules",
  "i18nKey": "course_module",
  "camelizedLower": "courseModule",
  "name": "CourseModule",
  "nameDasherized": "course-module",
  "pluralName": "course_modules",
  "ransackable_associations": [
    {
      "className": "CourseModule::Audit",
      "collectionName": "course_module_audits",
      "foreignKey": "course_module_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "CourseModuleAudit",
      "through": null
    },
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "CourseModule::Audit",
      "collectionName": "course_module_audits",
      "foreignKey": "course_module_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "CourseModuleAudit",
      "through": null
    },
    {
      "className": "CourseModule::Translation",
      "collectionName": null,
      "foreignKey": "course_module_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SchoolClassCourseModule",
      "collectionName": "school_class_course_modules",
      "foreignKey": "course_module_id",
      "name": "school_class_course_modules",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseModule",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "CourseModule::Translation",
      "collectionName": null,
      "foreignKey": "course_module_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "course_id",
      "column": {
        "default": null,
        "name": "course_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "expected_minutes",
      "column": {
        "default": null,
        "name": "expected_minutes",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "position",
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    }
  ],
  "paramKey": "course_module",
  "primaryKey": "id"
}

/** Frontend model for CourseModule. */
class CourseModule extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  courseId() {
    return this.readAttributeUnderscore("course_id")
  }

  /** @returns {boolean} */
  hasCourseId() {
    const value = this.courseId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  expectedMinutes() {
    return this.readAttributeUnderscore("expected_minutes")
  }

  /** @returns {boolean} */
  hasExpectedMinutes() {
    const value = this.expectedMinutes()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  appetizer() {
    return this.readAttributeUnderscore("appetizer")
  }

  /** @returns {boolean} */
  hasAppetizer() {
    const value = this.appetizer()

    return this._isPresent(value)
  }

  /** @returns {any} */
  appetizerDa() {
    return this.readAttributeUnderscore("appetizer_da")
  }

  /** @returns {boolean} */
  hasAppetizerDa() {
    const value = this.appetizerDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  appetizerEn() {
    return this.readAttributeUnderscore("appetizer_en")
  }

  /** @returns {boolean} */
  hasAppetizerEn() {
    const value = this.appetizerEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  appetizerNo() {
    return this.readAttributeUnderscore("appetizer_no")
  }

  /** @returns {boolean} */
  hasAppetizerNo() {
    const value = this.appetizerNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  appetizerSe() {
    return this.readAttributeUnderscore("appetizer_se")
  }

  /** @returns {boolean} */
  hasAppetizerSe() {
    const value = this.appetizerSe()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("./course.js").default | null} */
  course() {
    return this._readBelongsToReflection({reflectionName: "course"})
  }

  /** @returns {Promise<import("./course.js").default | null>} */
  loadCourse() {
    if (!("courseId" in this)) throw new Error("Foreign key method wasn't defined: courseId")

    const id = this.courseId()
    const modelClass = modelClassRequire("Course")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "course", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const modelClass = modelClassRequire("Survey")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "survey", model: this, modelClass},
      {ransack}
    )
  }
}

export default CourseModule
